<template>
  <div class="add-client-modal">
    <v-dialog v-model="dialog" :max-width="maxWidth" persistent @keyup.esc="dialog = false">
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
        <v-card-title class="justify-space-between">
          <div class="add-client-modal--title fw-600" :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs }">
            Add New Client
          </div>
          <v-btn v-if="!breakpointXs" icon @click="$emit('close-client-modal', true)">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="{ 'pt-5': !breakpointXs, 'pt-0': breakpointXs }">
          <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
            <v-row>
              <v-col>
                <TextField
                  v-model="exporter.name"
                  rules="required|max:50"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="Name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextField
                  v-model="exporter.iec"
                  rules="required|max:10"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="IEC"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextField
                  v-model="exporter.address1"
                  rules="required|max:35"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="Address 1"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextField
                  v-model="exporter.address2"
                  rules="required|max:25"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="Address 2"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="exporter.branch"
                  rules="required|max:3"
                  type="number"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="Branch Code"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="exporter.city"
                  :items="cities"
                  item-text="text"
                  rules="required"
                  :loading="isAddClientFormLoading"
                  label="City"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="exporter.state"
                  :items="states"
                  item-text="text"
                  item-value="text"
                  rules="required"
                  :loading="isAddClientFormLoading"
                  label="State"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="exporter.pin"
                  rules="required|max:7"
                  type="number"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="Pin"
                />
              </v-col>

              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="exporter.gstnType"
                  :items="gstInTypes"
                  item-text="text"
                  item-value="textIdentifier"
                  rules="required"
                  :loading="isAddClientFormLoading"
                  label="GST Type"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="exporter.gstId"
                  rules="required"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="GST ID"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="exporter.adCode"
                  required
                  v-if="exporter.action === 'add'"
                  rules="required"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="Ad Code"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="exporter.bankName"
                  required
                  rules="required"
                  v-if="exporter.action === 'add'"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAddClientFormLoading"
                  label="Bank Name"
                />
              </v-col>
            </v-row>
            <v-card-actions class="d-block d-sm-flex justify-end">
              <v-btn
                color="button-primary"
                outlined
                large
                :block="breakpointXs"
                width="140"
                @click="$emit('close-client-modal', false)"
              >
                <span class="font-weight-bold fs-15">Cancel</span>
              </v-btn>
              <v-btn
                width="140"
                color="button-primary"
                large
                v-if="exporter.action === 'add'"
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="loader"
                @click="passes(addClient)"
              >
                <span class="font-weight-bold fs-15">add</span>
              </v-btn>
              <v-btn
                width="140"
                color="button-primary"
                large
                v-if="exporter.action === 'edit'"
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="loader"
                @click="passes(editClient(exporter))"
              >
                <span class="font-weight-bold fs-15">Update</span>
              </v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import AutoComplete from "@/components/AutoComplete";
import cities from "@/packages/dataFiles/cities.json";
import states from "@/packages/dataFiles/states.json";
import gstInTypes from "@/packages/dataFiles/gstInTypes.json";
import * as AT from "@/modules/DashboardModule/modules/ImportExportModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "AddClientModal",
  components: {
    ValidationObserver,
    TextField,
    AutoComplete
  },
  data() {
    return {
      dialog: true,
      isAddClientFormLoading: false
    };
  },
  props: {
    maxWidth: {
      type: String,
      default: "450"
    },
    loader: {
      type: Boolean,
      default: false
    },
    exporter: {
      type: Object,
      default: () => {
        return {
          name: "",
          iec: "",
          address1: "",
          address2: "",
          branch: "",
          city: "",
          state: "",
          pin: "",
          gstnType: "",
          gstId: "",
          action: "add",
          bankName: "",
          adCode: ""
        };
      }
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    addClient(exporter) {
      this.$emit("add-client-modal", exporter);
      return;
    },
    editClient(exporter) {
      this.$emit("edit-client-modal", exporter);
      return;
    }
  },
  computed: {
    cities() {
      const citiesState = this.$store.getters.cities;
      if (citiesState === null || citiesState.length === 0) {
        let citiesData = {
          cities: cities.cities
        };
        this.$store.dispatch(AT.STORE_CITIES, citiesData);
      }
      return this.$store.getters.cities;
    },
    states() {
      const statesState = this.$store.getters.states;
      if (statesState === null || statesState.length === 0) {
        let statesData = {
          states: states.states
        };
        this.$store.dispatch(AT.STORE_STATES, statesData);
      }
      return this.$store.getters.states;
    },
    gstInTypes() {
      const gstInTypesState = this.$store.getters.gstInTypes;
      if (gstInTypesState === null || gstInTypesState.length === 0) {
        let gstInTypesData = {
          gstInTypes: gstInTypes.gstInTypes
        };
        this.$store.dispatch(AT.STORE_GST_IN_TYPES, gstInTypesData);
      }
      return this.$store.getters.gstInTypes;
    }
  }
};
</script>
